import { useMutation } from '@tanstack/react-query'
import { loginRequest } from '@/api/auth.api'
import { StoreAuth } from '@/store/store.auth'

export const useLogin = () => {
  // const setToken = useAuthStore((state) => state.setToken)
  // console.log(StoreAuth.getState().token)
  return useMutation({
    mutationFn: loginRequest,
    onSuccess: (data) => {
      StoreAuth.getState().setToken(data.token)
    }
  })
}
